import { get, isEmpty } from 'lodash';
import { UnavailableProductOptionData } from '../../reservations/res/UnavailableProductOption';

class AppError {
  readonly statusCode?: number;

  readonly message?: string;

  // 서버 응답 response.data.message 원본 (message가 translate로 바뀌어도 보존)
  readonly code?: string;

  readonly translate?: string;

  readonly error?: unknown;

  readonly data?:
    | { nameList: string[] }
    | string[]
    | UnavailableProductOptionData;

  constructor(e: unknown) {
    this.statusCode = get(e, 'response.data.statusCode') as unknown as number;
    if (typeof get(e, 'response.data.translate') === 'string') {
      this.message = get(e, 'response.data.translate');
    } else {
      this.message = get(e, 'response.data.message') as unknown as string;
    }

    this.translate = get(e, 'response.data.translate') as string | undefined;
    const rawCode = get(e, 'response.data.message');
    this.code = typeof rawCode === 'string' ? rawCode : undefined;
    this.data = get(e, 'response.data.data') as
      | { nameList: string[] }
      | string[]
      | UnavailableProductOptionData
      | undefined;

    if (
      isEmpty(this.translate) &&
      typeof get(e, 'response.data.message') !== 'string'
    ) {
      if (Array.isArray(this.message)) {
        this.message = String(this.message);
      } else if (typeof this.message === 'object') {
        this.message = JSON.stringify(this.message);
      } else {
        this.message = String(e);
      }
    }

    this.error = get(e, 'response.data.error');
  }
}

export default AppError;
